module.exports = __webpack_public_path__ + "img/hover_icon_cogs.b4036e9e.svg";